import React, {FC, memo, useCallback} from 'react';
import './App.css';
import {Route, Routes, useNavigate} from "react-router-dom";
import {Home} from "./pages/Home";
import {Activation} from "./pages/Activation";
import {Header} from "./components/common/Header";
import { Footer } from './components/common/Footer';
import { Flex, Spacer } from '@chakra-ui/react';
import { NotFound } from './pages/NotFound';
import { useTranslation } from 'react-i18next';
import { useColorModeValue } from './components/ui/color-mode';

type Props = {

}

export const App: FC<Props> = memo((props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const bg = useColorModeValue("white", "black");

    const onClickHeader = useCallback(() => {
        navigate("/");
    }, [navigate]);

    const onClickNavigation = useCallback((path) => {
        navigate(path);
    }, [navigate]);

    return (
        <React.Fragment>
            <Flex bg={bg} direction="column" minHeight="100vh">
                <Header onClickHeader={onClickHeader} onClickNavigation={onClickNavigation} />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Activation" element={<Activation />} />
                    <Route path="/ContactUs" Component={() => {window.location.href = t("contact.link"); return null;}} />
                    <Route path='/*' element={<NotFound />} />
                </Routes>
                <Spacer />
                <Footer />
            </Flex>
        </React.Fragment>
    );
});
